// extracted by mini-css-extract-plugin
module.exports = {"max-viewport-width":"1160px","root":"StoryStream-module--root--cd693c"};